/**
 *
 * InfoCard
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Card } from 'antd';
//const { Meta } = Card;

function InfoCard({
  title,
  // actions
  editACtion,
  // default
  children,
  className,
  ...rest
}) {
  const childClassNames = classNames('details-card', className);

  return (
    title && (
      <Card
        className={childClassNames}
        title={title}
        bordered={false}
        extra={
          editACtion && <span onClick={editACtion} className='details-card__action'>modifier</span>
        }
        {...rest}
      >
        {children || '--'}
      </Card>
    )
  );
}

InfoCard.propTypes = {};

export default memo(InfoCard);
